import 'react-pdf/dist/Page/AnnotationLayer.css';

import { PDFDocumentProxy } from 'pdfjs-dist';
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

type Props = {
  fileUrl: string;
};

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PDFMobileViewer = ({ fileUrl }: Props) => {
  const [numPages, setNumPages] = useState(0);

  const onLoadSuccess = (pdf: PDFDocumentProxy) => {
    setNumPages(pdf.numPages);
  };
  const onError = (error: Error) => {
    console.log('Error loading PDF:', error);
  };

  return (
    <Document file={fileUrl} onLoadSuccess={onLoadSuccess} onLoadError={onError}>
      {Array.from({ length: numPages || 0 }, (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      ))}
    </Document>
  );
};
